import { Component, signal, ChangeDetectorRef } from '@angular/core';
import { RouterOutlet, Router, RouterLink, RouterLinkActive } from '@angular/router'; // 🚀 INYECTADO: Navegación nativa
import { CommonModule } from '@angular/common'; // 🚀 INYECTADO: Desbloquea ngIf y pipes de texto en el menú
import { HttpClientModule } from '@angular/common/http';

/* import { CustomerList } from './component/customer-list/customer-list';
import { UdcList } from './component/udc-list/udc-list';
import { CustomerAdd } from './component/customer-add/customer-add';
import { UdcAdd } from './component/udc-add/udc-add'; */

import { AuthService } from '../app/Service/auth'; // Tu servicio de seguridad nativo
import { ToastService } from '../app/Service/toast-service'; // Para la alerta de salida segura

@Component({
  selector: 'app-root',
  standalone: true, // Asegura el estándar moderno de Angular
  imports: [
    CommonModule,     // 🔓 Desbloquea directivas estructurales (*ngIf) en tu app.html
    RouterOutlet, 
    RouterLink,       // 🔓 Permite usar routerLink="/customers" en la barra horizontal
    RouterLinkActive, // 🔓 Enciende la pestaña activa en color azul/blanco automáticamente
    HttpClientModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('ejemplo1');

  // =========================================================================
  // 🚀 INYECCIÓN MAESTRA DE CONTEXTO DE SEGURIDAD GENERAL
  // =========================================================================
  constructor(
    public authService: AuthService, // Dejar strictly 'public' para que el HTML pueda leer los roles en vivo
    public router: Router,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  /**
   * 🚪 BOTÓN SEGURO DE DESCONEXIÓN UNIVERSAL:
   * Destruye el token de la f0002_user, dispara el Toast de despedida 
   * y bloquea las pestañas horizontales ocultando el menú al instante.
   */
  ejecutarCerrarSesion(): void {
    // Destruye el localStorage de forma segura contra SSR
    this.authService.logout();

    this.toastService.showSuccess(
      'Sesión Finalizada',
      'Ha salido del ecosistema transaccional del taller de forma segura. Cambie de usuario.'
    );

    // Devolvemos la tablet o monitor al Login de inmediato
    this.router.navigate(['/login']);
    this.cdr.detectChanges(); // Fuerza a Angular a esconder las pestañas en ese milisegundo
  }
}
